import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  useTransition,
} from "react";
import "./CadastroReceitaBX.scss";
import { useForm } from "react-hook-form";
import GlobalContext from "@context/GlobalContext";
import UtilServices from "@services/UtilServices";
import DropDownList from "@components/dropDownList/DropDownList";
import Grid from "@components/grid/Grid";
import mappingColumn from "@components/grid/mappingColumn";
import Modal from "@components/modal/Modal";
import useLoading from "@hooks/useLoading";
import EndPointServices from "@services/ApiServices";
import Button from "@components/button/Button";
import MessageServices from "@services/MessageServices";

const CadastroReceitaBX = () => {
  const [isPending, startTransition] = useTransition();
  useLoading(isPending);

  // Segundo formulário
  const {
    register: register,
    handleSubmit: handleSubmit,
    formState: { errors: errors },
    setValue: setValue,
    reset: reset,
    watch: watch,
  } = useForm();

  //Variaveis Padrões
  const [state] = useContext(GlobalContext);

  //input arquivo massivo .txt.
  const [dadosEmpresa, setDadosEmpresa] = useState([]);
  const [ids_empresa, setIdsEmpresa] = useState([]);

  //Modal
  const [showModal, setShowModal] = useState(false);
  const [retornoErros, setRetornoErros] = useState([]);

  const [valueDropDownLst, setValueDropDownLst] = useState([]);

  useEffect(() => {
    handleConsultaEmpresa();
  }, []);

  async function handleCadastrar(e) {
    if (ids_empresa.length === 0) {
      MessageServices.ShowWarning(
        "É obrigatório selecionar ao menos uma empresa no grid.",
      );
      return;
    }

    startTransition(async () => {
      let dados = {
        periododeconsultabx: valueDropDownLst["periododeconsultabx"].key,
        intervaloconsultabx: valueDropDownLst["intervaloconsultabx"].key,
        ids_empresa: ids_empresa.map((item) => ({
          id_empresa: item.id_empresa,
        })),
      };

      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        json: dados,
      };

      var retornoapi = await EndPointServices.ReceitaBX_CadastraConsulta(data);
      if (retornoapi?.Success) {
        MessageServices.ShowSuccess("Cadastro da consulta feita com sucesso!");
        setValueDropDownLst([]);
        setIdsEmpresa([]);
        handleConsultaEmpresa();
      }
    });
  }

  async function handleConsultaEmpresa() {
    startTransition(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
      };

      var retornoapi = await EndPointServices.Rpa_ConsultaLstEmpresa(data);
      if (retornoapi?.Success) {
        setDadosEmpresa(retornoapi?.BaseReturn?.LstClasse);
      }
    });
  }
  function handleChangeDropDownLst(name, value, valueAdicionar) {
    setValue(name, value);
    setValueDropDownLst((prevState) => ({
      ...prevState,
      [name]: valueAdicionar,
    }));
  }

  return (
    <div className="cadastrarempresarpa">
      {/* Importação Massivo */}
      <form onSubmit={handleSubmit(handleCadastrar)} className="row mb-4">
        <div className="col-12 d-flex justify-content-end">
          <Button
            nome={"Cadastrar"}
            icon={"<i class='fa-solid fa-plus'></i>"}
            theme="2"
          />
        </div>
        <div className="col-md-4 col-12">
          <DropDownList
            title="*Período de Consulta"
            placeholder="Selecione o período desejado"
            setValue={setValue}
            register={register}
            errors={errors}
            required
            name="periododeconsultabx"
            value={valueDropDownLst["periododeconsultabx"]}
            onChange={handleChangeDropDownLst}
            data={[
              { id: 0, key: "Ano Atual" },
              { id: 1, key: "Últimos 2 anos" },
              { id: 2, key: "Últimos 3 anos" },
              { id: 3, key: "Últimos 4 anos" },
              { id: 4, key: "Últimos 5 anos" },
            ]}
            registerProps={{
              required: "Campo obrigatório",
            }}
            tooltip
            tooltipDescricao="Selecione o período para o qual deseja consultar os dados de receita."
            tooltipId="tooltip-001"
            tooltipIconColor="#FFDF5E"
            tooltipIcon={<i class="fa-regular fa-question"></i>}
          />
        </div>
        <div className="col-md-4 col-12">
          <DropDownList
            title="*Intervalo da Consulta"
            placeholder="Escolha o intervalo desejado"
            setValue={setValue}
            register={register}
            errors={errors}
            required
            name="intervaloconsultabx"
            value={valueDropDownLst["intervaloconsultabx"]}
            onChange={handleChangeDropDownLst}
            data={[
              { id: 0, key: "Somente desta vez" },
              { id: 1, key: "A cada 1 mês" },
              { id: 2, key: "A cada 6 meses" },
              { id: 3, key: "A cada 1 ano" },
            ]}
            registerProps={{
              required: "Campo obrigatório",
            }}
            tooltip
            tooltipDescricao="Escolha um intervalo de consulta para que o processo ocorra automaticamente."
            tooltipId="tooltip-001"
            tooltipIconColor="#FFDF5E"
            tooltipIcon={<i class="fa-regular fa-question"></i>}
          />
        </div>
      </form>
      <div
        style={{ padding: "5px", borderRadius: "15px", marginBottom: "20px" }}
      >
        <Grid
          className="passo-6"
          dadosGrid={dadosEmpresa}
          columns={mappingColumn.getRPA_EmpresasReceitaBX(dadosEmpresa)}
          {...(dadosEmpresa.length > 0 && {
            pageVisible: true,
          })}
          selection={{
            allowSelectAll: true,
            mode: "multiple",
            showCheckBoxesMode: "always",
          }}
          exportExcel={false}
          columnSelector={false}
          searchPanel={false}
          Memo={false}
          useLoading={isPending}
          pagingStaticSize="10"
          iconTitle="<i class='fa-solid fa-users'></i>"
          title="Quais empresas deseja consultar ? "
          onSelectionChanged={(e) => {
            setIdsEmpresa(e.selectedRowKeys);
          }}
        />
      </div>
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        title="Alertas"
        width="auto"
        height="500px"
      >
        <div className="retorno-erros">
          {Object.entries(retornoErros).map(([msg, items], index) => (
            <div
              key={index}
              style={{ marginBottom: "2rem" }}
              className="grupo-erros"
            >
              <div dangerouslySetInnerHTML={{ __html: msg }} />
              {items.map((item, i) => (
                <div
                  key={i}
                  style={{ marginLeft: "1rem", marginTop: "0.5rem" }}
                >
                  <p>
                    <strong>{item.razaosocial}</strong>
                  </p>
                  <p>{UtilServices.maskCNPJ(item.cnpj)}</p>
                </div>
              ))}
              <hr
                style={{
                  borderTop: "1px solid #ccc",
                  margin: "10px auto",
                  width: "350px",
                }}
              />
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
};

export default CadastroReceitaBX;
